import { t } from './ui'

export const ORDER_STATUS = {
  sent:      { label: '📤 Devis envoyé',        court: 'Devis envoyé', tone: 'amber',   accent: t.amber },
  validated: { label: '✅ Validé client',        court: 'Validées',     tone: 'green',   accent: t.green },
  scheduled: { label: '🚛 Livraison planifiée',  court: 'Planifiées',   tone: 'blue',    accent: t.blue },
  delivered: { label: '📦 Livré',                court: 'Livrées',      tone: 'neutral', accent: '#8A8F93' },
}

/* Ordre d'affichage des sections de la liste : ce qui demande une action
   d'abord, l'archive des livraisons en dernier. */
export const GROUP_ORDER = ['scheduled', 'validated', 'sent', 'delivered']

/* Ordre réel du cycle de vie d'une commande. Sert aux boutons de statut :
   les enchaîner dans l'ordre du carnet donnerait une suite incohérente. */
export const WORKFLOW_ORDER = ['sent', 'validated', 'scheduled', 'delivered']

const JOUR_MS = 864e5
const minuit = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x }

/* « demain », « dans 3 j », « en retard de 2 j » */
export function echeance(dateLivraison) {
  if (!dateLivraison) return null
  const j = Math.round((minuit(dateLivraison) - minuit(new Date())) / JOUR_MS)
  if (j === 0) return { texte: "aujourd'hui", tone: 'urgent' }
  if (j === 1) return { texte: 'demain', tone: 'urgent' }
  if (j < 0) return { texte: `en retard de ${-j} j`, tone: 'late' }
  if (j <= 7) return { texte: `dans ${j} j`, tone: 'soon' }
  return { texte: `dans ${j} j`, tone: 'far' }
}

/* Nature du document. `devis` reste réservé aux offres ; les demandes
   venues du formulaire du site vivent dans la table `quotes` et ne sont
   pas des commandes. */
export const ORDER_TYPES = {
  devis:    { label: '📋 Devis',     tone: 'neutral' },
  proforma: { label: '📄 Pro forma', tone: 'amber' },
  facture:  { label: '🧾 Facture',   tone: 'blue' },
}

/* TVA française : suivie sur les factures livrées, pour les ventes en
   France. Volontairement hors du total — le client suisse n'en voit
   jamais la trace, et une commande qui en porte une est française. */
export const TAUX_TVA = [5.5, 20]

export function tvaDe(ligne) {
  const pct = parseFloat(ligne?.tva_pct) || 0
  if (!pct) return { pct: 0, montant: 0 }
  const prix = parseFloat(ligne.prix_100kg) || 0
  const poids = parseFloat(ligne.poids_t) || 0
  return { pct, montant: ((prix * pct) / 100) * poids * 10 }
}

export const tvaTotaleDe = (lignes) =>
  (lignes || []).reduce((acc, l) => acc + tvaDe(l).montant, 0)

/* Capacité d'un camion remorque, en tonnes.
   Seul endroit où ce chiffre est défini : tout le reste s'y réfère. */
export const CAPACITE_CAMION = 28

/* Calcul d'une ligne de commande. Les frais de douane sont un montant
   forfaitaire : ni poids, ni prix au 100 kg, ni camion. */
export function calcLigne(l) {
  if (l.produit === 'Frais de douane') {
    const total = parseFloat(l.prix_100kg) || 0
    return { p: 0, pr: total, tx: 0, nb: 0, total }
  }
  const p = parseFloat(l.poids_t) || 0
  const pr = parseFloat(l.prix_100kg) || 0
  const tx = parseFloat(l.taxe_100kg) || 0
  const nb = parseInt(l.nb_camions) || Math.ceil(p / CAPACITE_CAMION) || 1
  return { p, pr, tx, nb, total: (pr + tx) * p * 10 }
}


/* Camions calculés sur le poids TOTAL de la commande : un camion
   transporte plusieurs marchandises, l'arrondi ligne par ligne
   surestimait le nombre de rotations. */
export const camionsAuto = (poidsTotal) =>
  Math.ceil((parseFloat(poidsTotal) || 0) / CAPACITE_CAMION) || 1

/* Valeur affichée : la saisie manuelle prime sur le calcul. */
export const camionsDe = (order) =>
  order?.nb_camions_total != null ? order.nb_camions_total : camionsAuto(order?.poids_total_t)

/* Normalise les lignes et recalcule les totaux de la commande. */
export function totauxDe(lignes) {
  const data = lignes.map((l) => {
    const c = calcLigne(l)
    return {
      produit: l.produit,
      poids_t: c.p,
      bottes: l.bottes === '' || l.bottes == null ? null : parseInt(l.bottes, 10),
      tva_pct: l.tva_pct === '' || l.tva_pct == null ? null : parseFloat(l.tva_pct),
      prix_100kg: c.pr,
      taxe_100kg: c.tx,
      nb_camions: c.nb,
      sous_total: c.total,
    }
  })
  const poids_total_t = data.reduce((a, l) => a + l.poids_t, 0)
  return {
    lignes: data,
    poids_total_t,
    ca_total_chf: data.reduce((a, l) => a + l.sous_total, 0),
    nb_camions: camionsAuto(poids_total_t),
  }
}

export const fmtLong = (d) =>
  new Date(d).toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })
